.container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 24px;
}

.backLink {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #1eb1e7;
  text-decoration: none;
  margin-bottom: 1.6px;

  &:hover {
    color: #1eb1e7;
    text-decoration: none;
  }
}

.backLinkIcon {
  font-size: 16px;
}

.intro {
  display: block;
  font-size: 25px;
  font-weight: 700;
  color: var(--green2) !important;
  margin: 0;
}

.panel {
  background: var(--neutral6);
  border-radius: 6px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 32px;

  > * {
    margin: 0 40px;
  }
}

.panelHeader {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
}

.panelLogo {
  width: 40px;
  height: 40px;
}

.panelTitle {
  font-size: 24px;
  font-weight: 700;
  color: var(--dark);
}

.steps {
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
}

.step {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.stepNumber {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: transparent;
  color: var(--neutral7);
  font-weight: 700;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--neutral7);
  flex-shrink: 0;
}

.stepText {
  margin: 0;
  font-size: 12px;
  line-height: 1.4;
  color: var(--neutral7);
}

.status,
.success {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.status {
  align-items: center;
  text-align: center;
}

.statusDescription {
  display: inline-block;
  margin-top: 16px;
  font-size: 16px;
  font-weight: 600;
  color: var(--neutral8) !important;
}

.codeCard {
  background: var(--white);
  border: 1px dashed var(--neutral2);
  border-radius: 12px;
  width: min(360px, 90vw);
  height: min(360px, 90vw);
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.codeImage {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}

.copyButton {
  align-self: center;
  padding: 12px 40px;
  min-width: 30%;
  border-radius: 6px;
  border: none;
  background: #1eb1e7;
  color: var(--white);
  font-weight: 700;
  letter-spacing: 0.5px;
  transition: opacity 0.2s ease-in-out;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.copyButton:hover {
  opacity: 0.85;
}

.copyButton:active {
  opacity: 0.7;
}

.copyButtonSuccess {
  background: var(--green1);
}

.copyButtonIcon {
  font-size: 16px;
}

.expiration {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  color: var(--neutral5);
}

.expirationText {
  font-weight: 700;
  color: var(--dark);
}

.expirationLoader :global(svg) {
  color: var(--dark);
}

.statusNote {
  font-size: 14px;
  color: var(--neutral5);
  margin: 0;
}

.actionButton {
  margin-top: 16px;
  padding: 12px 32px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.success {
  align-items: center;
  text-align: center;
}

.successIcon {
  font-size: 56px;
  color: var(--green1);
}

.successActions {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
}

.successButton {
  padding: 12px 24px;
  border-radius: 999px;
  border: 2px solid var(--green1);
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;
}

.successButtonOutline {
  @extend .successButton;
  background: transparent;
  color: var(--green1);
}

.successButtonSolid {
  @extend .successButton;
  background: var(--green1);
  color: var(--white);
}

.successButton:hover {
  opacity: 0.85;
}

.successDescription {
  margin: 0;
  font-size: 15px;
  color: var(--neutral5);
}

.banner {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border-radius: 6px;
  font-weight: 600;
  text-align: center;
}

.bannerPending {
  background: #FFF0B4;
  color: var(--warning1);
}

.bannerSuccess {
  background: rgba(16, 176, 138, 0.18);
  color: var(--green1);
}

.bannerIcon {
  font-size: 22px;
}

.bannerText {
  font-size: 16px;
  color: var(--neutral8);
}
